import PolygonBase from './PolygonBase';
import shapeTrapezoid from '../assets/icons/shapeTrapezoid.svg';
import { svgToIcon } from '../utils/svg';
import { AttachmentPoint } from '../types';

class ShapeTrapezoid extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeTrapezoid);
  }

  static connectControlDefinition() {
    return {
      ...super.connectControlDefinition(),
      cl: {
        x: -0.35,
        y: 0,
        normal: { x: -1, y: 0 },
        oppositeAttachmentPoint: AttachmentPoint.Right,
      },
      cr: {
        x: 0.35,
        y: 0,
        normal: { x: 1, y: 0 },
        oppositeAttachmentPoint: AttachmentPoint.Left,
      },
    };
  }

  calcTextMargin() {
    const { width } = this.fabricObject;

    return {
      top: 5,
      left: 0.3 * width,
      right: 0.3 * width,
      bottom: 5,
    };
  }

  static pathString() {
    return `
      M -0.5 0.5
      L -0.2 -0.5
      L 0.2 -0.5
      L 0.5 0.5
      Z
    `;
  }
}

export default ShapeTrapezoid;
